const secondary = {
    social_bind_with: 'هل لديك حساب بالفعل؟ قم بتسجيل الدخول لربط {{methods, list(type: disjunction;)}} بالهوية الاجتماعية الخاصة بك.',
};
export default Object.freeze(secondary);
